import React from 'react';
import { Route } from '../Routing/types';
import {
  PATH_DAY_PLAN_INDEX_WITH_DATE,
  PATH_DAY_PLAN_MEAL_DETAILS,
  PATH_DAY_PLAN_REPLACE_MEAL,
  PATH_DAY_PLAN_REPLACE_DAY,
  PATH_SHOPPING_LIST,
  PATH_FAV_MEALS,
  PATH_FAV_MEAL_DETAILS,
  PATH_TRACKER_ADD_MEAL,
  PATH_TRACKER_ADD_FAV_MEAL,
  PATH_TRACKER_ADD_INGREDIENT,
  PATH_TRACKER_ADD_INGREDIENT_SCAN_BARCODE,
  PATH_TRACKER_ADD_INGREDIENT_FAV_MEAL,
  PATH_TRACKER_ADD_INGREDIENT_SCAN_BARCODE_FAV_MEAL,
} from './paths';

import {
  MealPlanIndexPage,
  MealDetailsPage,
  MealReplacementPage,
  DayReplacementPage,
  FavMealsIndexPage,
  FavMealPage,
  ShoppingListIndexPage,
  TrackerAddMealPage,
  TrackerAddFavMealPage,
  TrackerAddIngredientPage,
  TrackerScanBarCodeIngredientPage,
} from '@front-activerse/modules';

import { shoppingTipsArticleId } from '../ShoppingList/consts';
import mealPlanNavigation from '../navigation/mealsNavigation';

import { fetchRemoteConfigFields } from '../Firebase/firebaseRemoteConfig';
import { markNotificationAsClosed, getClosedNotifications } from '../Firebase/firebaseFirestoreDb';

import { trackerArticleId } from '../Tracker/consts';

const descendantRoutes: Route[] = [
  {
    path: PATH_DAY_PLAN_INDEX_WITH_DATE,
    element: (
      <MealPlanIndexPage
        mealPlanNavigation={mealPlanNavigation}
        fetchRemoteConfigFields={fetchRemoteConfigFields}
        markNotificationAsClosed={markNotificationAsClosed}
        getClosedNotifications={getClosedNotifications}
        trackerArticleId={trackerArticleId}
      />
    ),
    private: true,
    title: 'meals.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_DAY_PLAN_MEAL_DETAILS,
    element: <MealDetailsPage />,
    private: true,
    title: 'mealPlan.mealDetails.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_DAY_PLAN_REPLACE_MEAL,
    element: <MealReplacementPage />,
    private: true,
    title: 'mealPlan.changeMeal.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_DAY_PLAN_REPLACE_DAY,
    element: <DayReplacementPage />,
    private: true,
    title: 'mealPlan.changeMenu.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_SHOPPING_LIST,
    element: <ShoppingListIndexPage shoppingTipsArticleId={shoppingTipsArticleId} />,
    private: true,
    title: 'shoppingList.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_FAV_MEALS,
    element: <FavMealsIndexPage />,
    private: true,
    title: 'mealPlan.favorites.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_FAV_MEAL_DETAILS,
    element: <FavMealPage />,
    private: true,
    title: 'mealPlan.favorites.mealDetails.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_ADD_MEAL,
    element: <TrackerAddMealPage />,
    private: true,
    title: 'tracker.logMeal.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_ADD_FAV_MEAL,
    element: <TrackerAddFavMealPage />,
    private: true,
    title: 'tracker.logMeal.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_ADD_INGREDIENT,
    element: <TrackerAddIngredientPage />,
    private: true,
    title: 'tracker.logMeal.addIngredient.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_ADD_INGREDIENT_SCAN_BARCODE,
    element: <TrackerScanBarCodeIngredientPage />,
    private: true,
    title: 'tracker.scanBarcode.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_ADD_INGREDIENT_FAV_MEAL,
    element: <TrackerAddIngredientPage />,
    private: true,
    title: 'tracker.logMeal.addIngredient.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_ADD_INGREDIENT_SCAN_BARCODE_FAV_MEAL,
    element: <TrackerScanBarCodeIngredientPage />,
    private: true,
    title: 'tracker.scanBarcode.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
];

export default descendantRoutes;
